import { handleActions } from 'redux-actions';
import http from '../shared/http';
import intl from '../shared/intl';
import endpoints from '../../config/endpoints';

const DATA_FETCH_SUCCESS = 'user_api/data-fetch-success';
const DATA_FETCH_ERROR  = 'user_api/data-fetch-error';
const TOGGLE_API_LIST  = 'user_api/TOGGLE_API_LIST';

// initialState state
const initialState = {
	data: null,
	isExpanded: false,
	error: false
};

// actions
export const actions = {
	fetchData: () => dispatch => {
		const request = http({
			url: [`${endpoints.PROFILE.MANAGER}`],
			method:'get',
			actions:[
				DATA_FETCH_SUCCESS,
				DATA_FETCH_ERROR
			]
		});
		request(dispatch);
	},
	toggleApiList: () => dispatch => dispatch({ type: TOGGLE_API_LIST })
};

// reducers
const reducers = Object.assign({
	[DATA_FETCH_SUCCESS]: (state, action) => {
		const [ manager ] = action.payload.map(res => res.data);
		return { ...state, data: { manager }};
	},
	[DATA_FETCH_ERROR]: state => {
		return { ...state, error: true };
	},
	[TOGGLE_API_LIST]: state => {
		return { ...state, isExpanded: !state.isExpanded };
	}
});

export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	getData: state => state.userApi.data,
	getUserData: state => state.app.userData,
	getManager: state => state.userApi.data && state.userApi.data.manager,
	getIntl: state => intl(state)
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/user-api/index.js